
import { Component, Vue } from 'vue-property-decorator';
import HeaderLogo from '@/components/Layout/HeaderLogo.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';

@Component({ components: { HeaderLogo, ResponsiveContainer } })
export default class AuthLayout extends Vue {}
